import React from 'react'
import styles from './styles/Home.module.css'
import { useRouter } from './UseRouter'
import { URL_SHOWCASE_ABOUT } from '../../const'
import ReactPlayer from 'react-player/youtube'
import { RightOutlined } from '@ant-design/icons'

export default function IndexPage(props) {
  let name = props.artistName
  const router = useRouter(props)
  const hasVideo =
    props.profile.video && props.profile.video.trim() !== '' && props.profile.video.trim() !== 'https://www.youtube.com/embed/None'
  const getMainLayout = () => {
    if (hasVideo) {
      return (
        <div style={{ width: '100vw', height: '100vh' }}>
          <div style={{ display: 'flex', width: 'auto' }}>
            <h1 className={styles.mainTitle} style={{ zIndex: '1000', cursor: 'pointer', marginLeft: 20, marginTop: 20 }}>
              {name}
            </h1>
            <h1
              className={styles.mainEnter}
              style={{
                zIndex: '1000',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                marginLeft: 'auto',
                marginRight: 520,
                marginTop: 20
              }}
              onClick={async () => {
                await router.push(URL_SHOWCASE_ABOUT)
              }}
            >
              Enter
              <RightOutlined style={{ marginBottom: 6 }} />
            </h1>
          </div>
          <ReactPlayer
            url={props.profile.video + '?autoplay=1&amp;controls=0'}
            playing={true}
            width={'120vw'}
            height={'120vh'}
            style={{ marginTop: '-10vh' }}
          />
        </div>
      )
    } else {
      return (
        <div
          style={{
            width: '100vw',
            height: '100vh',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundImage: `url("${props.profile.image}")`
          }}
        >
          <div style={{ display: 'flex' }}>
            <h1 className={styles.mainTitle} style={{ zIndex: '1000', cursor: 'pointer', marginLeft: 20, marginTop: 20 }}>
              {name}
            </h1>
            <h1
              className={styles.mainEnter}
              style={{
                zIndex: '1000',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                marginLeft: 'auto',
                marginRight: 40,
                marginTop: 20
              }}
              onClick={async () => {
                await router.push(URL_SHOWCASE_ABOUT)
              }}
            >
              Enter
              <RightOutlined style={{ marginBottom: 6 }} />
            </h1>
          </div>
        </div>
      )
    }
  }

  return <div style={{ overflow: 'hidden', display: 'flex', alignItems: 'center', flexDirection: 'row' }}>{getMainLayout()}</div>
}
